import type { VFC } from 'react'
import { ActionsMenu } from '@opallabs/lapidary'

enum Subpage {
  Assets = 'assets',
  Calendar = 'moments',
  Timelines = 'timelines',
}

type ActionsMenuWithOptionsProps = Readonly<{
  createPresentationCallback(): void
  deleteCallback(): void
  duplicateCallback(): void
  editCallback(): void
  migrateMomentsCallback?(): void
  shareCallback?(): void
  subpage: Subpage
}>

export const ActionsMenuWithOptions: VFC<ActionsMenuWithOptionsProps> = ({
  createPresentationCallback,
  deleteCallback,
  duplicateCallback,
  editCallback,
  migrateMomentsCallback,
  shareCallback,
  subpage,
}) => {
  return (
    <ActionsMenu.Base align="start" tooltipContent="More Options" zIndex={999}>
      {shareCallback && (
        <>
          <ActionsMenu.Item onSelect={shareCallback}>
            Share Story
          </ActionsMenu.Item>
          <ActionsMenu.Separator />
        </>
      )}
      <ActionsMenu.Item onSelect={editCallback}>Edit Story</ActionsMenu.Item>
      <ActionsMenu.Item onSelect={duplicateCallback}>
        Duplicate Story
      </ActionsMenu.Item>
      <ActionsMenu.Item
        disabled={subpage !== Subpage.Calendar}
        onSelect={createPresentationCallback}
      >
        Create Presentation
      </ActionsMenu.Item>
      <ActionsMenu.Separator />
      <ActionsMenu.Item onSelect={migrateMomentsCallback}>
        Migrate Moments
      </ActionsMenu.Item>
      <ActionsMenu.Separator />
      <ActionsMenu.Item
        destructive={true}
        onSelect={deleteCallback}
        onKeyDown={(e) => e.stopPropagation()}
      >
        Delete Story
      </ActionsMenu.Item>
    </ActionsMenu.Base>
  )
}
ActionsMenuWithOptions.displayName = 'Continuum: ActionsMenuWithOptions'
